import { observer } from "mobx-react";
import * as React from "react";
import { WebNodeStore } from "../../../stores";
import { ResizableNodeView } from "../ResizableNodeView";
import { TopBar } from "../TopBar";
import "./../NodeView.scss";
import "./WebNodeView.scss";

interface WebNodeViewProps {
  store: WebNodeStore;
}

/**
 * This class represents the view for a website node.
 * It extends ResizableNodeView to support interactive resizing
 * while displaying website content sourced from the node store.
 */
@observer
export class WebNodeView extends ResizableNodeView<WebNodeStore> {
    
    /**
     * This getter method returns the CSS class name for the website node.
     * @returns Class name for the website node container.
     */
    protected getNodeClassName(): string {
        return "websiteNode";
    }

    /**
     * This method renders the visual content of the website node, 
     * including the top bar.
     * @returns Node representing the website node content
     */
    protected renderContent(): React.ReactNode {
        const store = this.props.store;

        return (
            <>
                <TopBar store={store} />
                <div className="content website-content">
                    <iframe
                        src={store.url}
                        width="100%"
                        height="100%"
                        style={{ border: "none" }}
                        sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
                    />
                </div>
            </>
        );
    }
}